import { $pay } from "@/utils/https.js";

export function getInvoices(params) {
    return $pay().get(`/api/pay/manage/invoice`, { params });
}

export function getInvoice(id) {
    return $pay().get(`/api/pay/manage/invoice/${id}`);
}

export function deleteInvoice(id) {
    return $pay().delete(`/api/pay/manage/invoice/${id}`);
}
// 开票
export function makeInvoice(id, data) {
    return $pay().put(`/api/pay/manage/invoice/${id}/make`, data);
}
// 驳回
export function refuseInvoice(id, data) {
    return $pay().put(`/api/pay/manage/invoice/${id}/refuse`, data);
}
// 备注
export function remarkInvoice(id, data) {
    return $pay().put(`/api/pay/manage/invoice/${id}/remark`, data);
}
// 重新发送
export function resendInvoice(id, data) {
    return $pay().post(`/api/pay/manage/invoice/${id}/resend`, data);
}

// 统计数量
export function countInvoiceFinance() {
    return $pay().get(`/api/pay/manage/finance/count`);
}

// 统计发票相关数量以及金额
export function countAmount(params) {
    return $pay().get(`/api/pay/manage/finance/count/amount`, { params });
}

// 统计图表
export function stateInvoice(params) {
    return $pay().get(`/api/pay/manage/finance/stat`, { params });
}
// 后台创建订单发票
export function makeOrderInvoice(data) {
    return $pay().post(`/api/pay/manage/invoice`, data);
}
